import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { setBasePath } from '@shoelace-style/shoelace';
import { enableProdMode } from '@angular/core';

setBasePath("/ui-forms/v1/public-v2/dist/assets/shoelace");

enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
